/**
 * Add-on facet for the reservations list. The ids are the API contract — they are sent
 * verbatim as a comma-separated `addOns` query param and must stay in sync with the backend's
 * Core/Constants/ReservationAddOnFilterConstants.cs.
 *
 * Selections are AND-ed server-side: picking "Premium Flex" and "Valixhe" returns only the
 * reservations carrying both, never the union of each. Ticking two flex tiers is therefore a
 * deliberate empty result — a reservation has exactly one FlexiRide type — and the list simply
 * renders nothing.
 */
export const RESERVATION_ADD_ON_FILTER = {
  selector: "addOns",
  options: [
    { label: "Ultra Flex", id: "ultraflex" },
    { label: "Premium Flex", id: "premiumflex" },
    { label: "Basic Flex", id: "basicflex" },
    { label: "SMS", id: "sms" },
    { label: "Valixhe", id: "luggage" },
    { label: "Open Return", id: "openreturn" }
  ]
};
